import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './lib/auth-context';
import { LoginPage } from './pages/Login';
import { DashboardPage } from './pages/Dashboard';
import { CalendarPage } from './pages/Calendar';
import { DocumentsPage } from './pages/Documents';
import { RegelsPage } from './pages/Regels';
import { SettingsPage } from './pages/Settings';
import { OnboardingPage } from './pages/Onboarding';
import { StatistiekenPage } from './pages/Statistieken';
/* CLAIM-D */
import { OnkostenPage } from './pages/Onkosten';
/* CLAIM-K */
import { AfwijkingenPage } from './pages/Afwijkingen';
import { VerlofPage } from './pages/Verlof';
import { ActiesPage } from './pages/Acties';
import { VragenPage } from './pages/Vragen';
/* CLAIM-P */
import { AdminPage } from './pages/Admin';
import { AppLayout } from './components/AppLayout';

export default function App() {
  const { loading, authenticated } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-slate-400">Laden...</div>
      </div>
    );
  }

  if (!authenticated) {
    return <LoginPage />;
  }

  return (
    <Routes>
      <Route path="/onboarding" element={<OnboardingPage />} />
      <Route element={<AppLayout />}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/kalender" element={<CalendarPage />} />
        <Route path="/documenten" element={<DocumentsPage />} />
        <Route path="/regels" element={<RegelsPage />} />
        <Route path="/vergelijking" element={<Navigate to="/afwijkingen" replace />} />
        <Route path="/statistieken" element={<StatistiekenPage />} />
        <Route path="/instellingen" element={<SettingsPage />} />
        {/* CLAIM-D */}
        <Route path="/onkosten" element={<OnkostenPage />} />
        {/* CLAIM-K */}
        <Route path="/afwijkingen" element={<AfwijkingenPage />} />
        <Route path="/verlof" element={<VerlofPage />} />
        <Route path="/acties" element={<ActiesPage />} />
        <Route path="/vragen" element={<VragenPage />} />
        <Route path="/meldingen" element={<Navigate to="/afwijkingen" />} />
        {/* CLAIM-P */}
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Route>
    </Routes>
  );
}
